
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import OffcanvasMenu from './OffcanvasMenu.vue';
import TopSearchBar from '../search/TopSearchBar.vue';
import BeehiveLogo from '../branding/BeehiveLogo.vue';
import { IUserState } from '@/store/contract';

const namespace: string = 'user';

@Component({
    components: {
        OffcanvasMenu,
        BeehiveLogo,
        TopSearchBar
    }
})
export default class TopNavbar extends Vue {
    @State(namespace) userState: IUserState;
}
